import { TimeZoneInfo, TimeZoneOffsets, TimeZones } from "../models";

export const getTimeZoneInfo = (name: TimeZones): TimeZoneInfo | undefined => {
    return TimeZoneOffsets.find((t) => t.guid === name);
};

export const getUserTimeOffsetMinutes = (): number => {
    return new Date().getTimezoneOffset();
};

export const handleChangeTimeZonelessDate = (utcStringToRender: string | undefined) => {
    if (!utcStringToRender) return undefined;
    const utcDate = new Date(utcStringToRender);
    const offset = utcDate.getTimezoneOffset();
    utcDate.setMinutes(utcDate.getMinutes() - offset);
    return utcDate.toISOString();
};

export const getTimeZonelessDisplayDate = (utcString: string | undefined) => {
    if (!utcString) return undefined;
    const date = new Date(utcString);
    const offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + offset);
    return date;
};

export const getMaxTimezoneOffsetForYear = (year: number = new Date().getFullYear()): number => {
    const jan1 = new Date(year, 0, 1);
    const jul1 = new Date(year, 6, 1);
    return Math.max(jan1.getTimezoneOffset(), jul1.getTimezoneOffset());
};

export const dateFallsDuringDst = (date: Date): boolean => {
    const jan1 = new Date(date.getFullYear(), 0, 1);
    const jul1 = new Date(date.getFullYear(), 6, 1);
    const offset = date.getTimezoneOffset();
    return offset < Math.max(jan1.getTimezoneOffset(), jul1.getTimezoneOffset());
};

export const clientObservesDST = (): boolean => {
    return new Date().getTimezoneOffset() < getMaxTimezoneOffsetForYear();
};

export const clientIsInDST = (): boolean => {
    const now = new Date();
    const jan1 = new Date(now.getFullYear(), 0, 1);
    const jul1 = new Date(now.getFullYear(), 6, 1);
    return now.getTimezoneOffset() < Math.max(jan1.getTimezoneOffset(), jul1.getTimezoneOffset());
};

export const timezoneObservesDST = (name: TimeZones): boolean => {
    const timeZoneInfo = getTimeZoneInfo(name);
    return !!timeZoneInfo?.dst;
};

export const getUtcDateString = (dateTimeString: string, timezoneGuid: TimeZones): string | undefined => {
    const timeZoneInfo = getTimeZoneInfo(timezoneGuid);
    if (!timeZoneInfo) {
        return undefined;
    }

    const date = new Date(dateTimeString);
    const tzObservesDST = timezoneObservesDST(timezoneGuid);
    const dateIsDuringDst = dateFallsDuringDst(new Date(dateTimeString));
    const shouldAdjustForDst = tzObservesDST && dateIsDuringDst;
    const hourDiff = timeZoneInfo.offset - (shouldAdjustForDst ? 1 : 0);
    date.setHours(date.getHours() + hourDiff);
    return date.toISOString();
};
